import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapAchFeeTemplateQueueDataFromServer } from "mappers";
import { feeTemplateService } from "services";
import { uiActions } from "store";
import { ErrorResponse, FeeTemplateQueueType } from "types";

const useAchFeeTemplateQueueQuery = ({
	companyId,
}: {
	companyId: string;
}) => {
	const dispatch = useDispatch();

	return useQuery(
		[`ach-fee-template`, companyId],
		() =>
		feeTemplateService.achFeeTemplatesGet({companyId}),
		{
			select: (data: { [key: string]: any }): FeeTemplateQueueType[] =>
				data?.map(mapAchFeeTemplateQueueDataFromServer),
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
			enabled: !!companyId,
		},
	);
};
export default useAchFeeTemplateQueueQuery;
